import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertIssueSyncingDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-alert-issue-syncing-detail',
	path: '/jira/ops/teams/:teamId/syncs/:syncId',
	exact: true,
};
